<template>
  <el-dialog title="Rechercher un client ou prospect" :visible.sync="visible" :close-on-click-modal="false" width="90%">
    <customer-search-form :values="form" @loading="handleLoading" @loaded="handleLoaded"></customer-search-form>

    <el-table :data="paginatedCustomers" v-loading="loading"  style="width: 100%" stripe border>
      <el-table-column label="Nom">
        <template slot-scope="scope">
          <customer :item="scope.row" v-on:click.native="close()"></customer>
        </template>
      </el-table-column>
      <el-table-column label="Suivi commercial">
        <template slot-scope="scope">
          <div v-if="loadingReminders">
            <pulse-loader color="#cccccc" size="8px"></pulse-loader>
          </div>
          <div v-else>
            <div v-if="models.reminders.find(reminder => reminder.customer_id === scope.row.id)">
              <reminder :item="models.reminders.find(reminder => reminder.customer_id === scope.row.id)"></reminder>
              (<user :item="users.find(user => user.id === models.reminders.find(reminder => reminder.customer_id === scope.row.id).user_id)"></user>)
            </div>
          </div>
          <div class="text-muted font-13">
            <strong>Dans le parc de </strong> :
            <span v-if="scope.row.user_id">
              <user :item="users.find(user => user.id === scope.row.user_id)"></user>
            </span>
            <span v-else>Aucun</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Contacts">
        <template slot-scope="scope">
          <customer present="contacts" :item="scope.row"></customer>
        </template>
      </el-table-column>
      <el-table-column label="Services">
        <template slot-scope="scope">
          <customer present="services" :item="scope.row"></customer>
        </template>
      </el-table-column>
      <el-table-column v-if="merge" label="Fusionner avec">
        <template slot-scope="scope">
          <div v-if="merge.id === scope.row.id">
            <el-button size="small" type="warning" disabled>Même fiche</el-button>
          </div>
          <div v-else-if="Object.keys(merge.sources).filter((n) => Object.keys(scope.row.sources).includes(n)).length > 0">
            <el-button size="small" type="warning" disabled>Même interface</el-button>
          </div>
          <div v-else>
            <el-button size="small" type="warning" v-on:click.native="close()" v-on:click="openMerge(scope.row, merge)">Fusionner</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      :current-page.sync="page.number"
      :page-size="page.size"
      layout="total, prev, pager, next"
      :total="customers.length">
    </el-pagination>
  </el-dialog>
</template>

<script>
  import _ from 'lodash'
  import Customer from '../Entities/Customer.vue'
  import Reminder from '../Entities/Reminder.vue'
  import CustomerSearchForm from '../Entities/Forms/CustomerSearchForm.vue'
  import User from '../Entities/User.vue'
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

  export default {
    components: {
      User,
      CustomerSearchForm,
      Reminder,
      Customer,
      PulseLoader
    },
    name: 'search-customer-modal',
    data () {
      return {
        visible: false,
        merge: null,
        loading: false,
        loadingReminders: false,
        customers: [],
        page: {
          number: 1,
          size: 20
        },
        form: {
          maxResults: 500,
          name: '',
          type: '',
          job_type: '',
          user_id: '',
          flag_active: '',
          sources: '',
          address_department: '',
          service_active_on: '',
          service_next_expiration_at: {
            from: null,
            to: null
          },
          service_no_quotes_since: '',
          invoice_unpaid: '',
          quotation_not_accepted: ''
        },
        models: {
          reminders: []
        }
      }
    },
    computed: {
      paginatedCustomers () {
        let start = (this.page.number - 1) * this.page.size
        let end = start + this.page.size

        return _.slice(this.customers, start, end)
      },
      users () {
        return this.$store.getters['users/all']
      }
    },
    watch: {
      visible (visible) {
        if (!visible) {
          this.reset()
        }
      },
      paginatedCustomers (customers) {
        let self = this

        self.loadingReminders = true
        this.$nexus.get('callcenter', 'reminders', {
          params: {
            where: {
              customer_id: {
                'IN': customers.map(customer => customer.id).join(',')
              }
            }
          }
        }).then(response => {
          self.models.reminders = response.data.data
          self.loadingReminders = false
        })
      }
    },
    mounted () {
      let self = this
      this.$model.customer.on('search', (options) => {
        self.visible = true
        self.merge = options.merge
        self.form = _.merge(self.form, options.form)
      })
    },
    methods: {
      handleLoading () {
        this.loading = true
      },
      handleLoaded ({form, customers}) {
        this.loading = false
        this.customers = customers
      },
      reset () {
        this.page = this.$options.data.apply(this).page
        this.form = this.$options.data.apply(this).form
      },
      close () {
        this.visible = false
      },
      openMerge (from, into) {
        this.$model.customer.fire('merge', {
          from, into
        })
      }
    },
  }
</script>



// WEBPACK FOOTER //
// SearchCustomerModal.vue?fd263e8a